<template>
    <div v-if="isShowPopup" class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex justify-center items-center z-50 p-4"
        @click.self="closedPopup()">
        <div class="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl md:w-[400px] w-full max-h-[90vh] overflow-hidden border border-white/20 flex flex-col"
            :class="{ 'animate-popupFadeIn': isShowPopup, 'animate-popupFadeOut': !isShowPopup }">
            
            <!-- Header -->
            <div class="bg-brand text-yellow-500 py-3.5 px-5 font-bold text-[18px] flex items-center justify-between shadow-sm relative z-10">
                <div class="flex items-center gap-2">
                    <font-awesome-icon :icon="['fas', 'qrcode']" /> Thiết lập mã QR
                </div>
                <button @click="closedPopup()" class="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white/90 hover:bg-white hover:text-brand transition-colors focus:outline-none">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
            </div>

            <!-- Body items -->
            <div class="p-6 overflow-y-auto flex flex-col items-center">
                <div class="text-[14px] text-gray-600 mb-5 font-medium text-center px-4">
                    Mở ứng dụng <span class="font-bold text-gray-800">Google Authenticator</span> và quét mã bên dưới
                </div>
                
                <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-200 mb-5 relative group overflow-hidden flex justify-center">
                    <div class="absolute inset-0 bg-brand/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <canvas class="relative z-10 rounded-sm" id="qrcode"></canvas>
                </div>

                <div class="w-full">
                    <p class="text-[12px] text-gray-400 font-semibold uppercase tracking-wider mb-2 text-center">Hoặc nhập mã khóa bí mật</p>
                    <div class="bg-gray-50 border border-gray-200 rounded-xl p-3 flex items-center justify-between group/secret hover:border-brand/40 transition-colors">
                        <span class="font-mono text-[14px] text-gray-800 tracking-widest font-bold">{{ secret || 'Đang tạo mã...' }}</span>
                        <button class="text-gray-400 hover:text-brand transition-colors p-1" title="Sao chép" @click="copySecret()">
                            <font-awesome-icon :icon="['fas', 'copy']" />
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Footer -->
            <div class="p-5 bg-gray-50/80 border-t border-gray-100 flex items-center justify-center gap-3 rounded-b-2xl">
                <button
                    class="flex-1 py-2.5 rounded-xl font-semibold border border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors shadow-sm"
                    @click="closedPopup()">Hủy</button>

                <button
                    class="flex-1 py-2.5 rounded-xl font-bold bg-brand text-white shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all"
                    @click="onOpenConfirmPopup">Xong</button>
            </div>
        </div>
        <SetupOtpConfirmPopup v-if="isShowConfirmSetupOtpPopup" :isShow="isShowConfirmSetupOtpPopup" @closed="onClosedSetupOtpConfirmPopup"/>
    </div>
</template>

<script>
import QRCode from 'qrcode';
import SetupOtpConfirmPopup from './SetupOtpConfirmPopup.vue';
export default {
    components: { 
        SetupOtpConfirmPopup
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        qrURL: {
            type: String,
            default: ''
        },
        secret: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isShowPopup: false,
            isShowConfirmSetupOtpPopup: false
        }
    },
    mounted() {
        if(this.isShow) {
            this.isShowPopup = true
            document.body.style.overflow = 'hidden'
        }
        this.$nextTick(() => {
            this.generateQRcode()
        })
    },
    beforeDestroy() {
        document.body.style.overflow = ''
    },
    methods: {
        onClosedSetupOtpConfirmPopup(e) {
            if(e) {
                this.closedPopup(true)
            }
            this.isShowConfirmSetupOtpPopup = false
        },

        onOpenConfirmPopup() {
            this.isShowConfirmSetupOtpPopup = true
        },

        generateQRcode() {
            if(this.qrURL) {
                QRCode.toCanvas(document.getElementById('qrcode'), this.qrURL, {
                    width: 150,
                    height: 150,
                    margin: 0.1,
                });
            }
        },
        closedPopup(returnData = false) {
            this.isShowPopup = false
            this.$nextTick(() => {
                this.$emit('closed', returnData)
            })
        },
        copySecret() {
            if (!this.secret) return;
            navigator.clipboard.writeText(this.secret).then(() => {
                this.$notify.success({
                    title: 'Đã sao chép!',
                    message: 'Khóa bí mật đã được chép vào khay.',
                });
            }).catch(err => {
                console.error("Lỗi khi copy: ", err);
            });
        },
    }
}
</script>

<style scoped>
@keyframes popupFadeIn {
    0% { opacity: 0; transform: translateY(10px); }
    100% { opacity: 1; transform: translateY(0); }
}
@keyframes popupFadeOut {
    0% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(10px); }
}
.animate-popupFadeIn { animation: popupFadeIn 0.4s forwards; }
.animate-popupFadeOut { animation: popupFadeOut 0.4s forwards; }
</style>